import { SVGProps } from 'react';

const SvgInsertLink = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M2.6 8c0-1.14.927-2.067 2.067-2.067h2.666V4.667H4.667a3.335 3.335 0 0 0 0 6.666h2.666v-1.266H4.667A2.068 2.068 0 0 1 2.6 8Zm2.733.667h5.334V7.333H5.333v1.334Zm6-4H8.667v1.266h2.666c1.14 0 2.067.927 2.067 2.067 0 1.14-.927 2.067-2.067 2.067H8.667v1.266h2.666A3.335 3.335 0 0 0 14.667 8a3.335 3.335 0 0 0-3.334-3.333Z" />
    </svg>
);
export default SvgInsertLink;
